import type { CityConfig } from "../city-template/types";

export const mishawakaConfig: CityConfig = {
  city: "Mishawaka",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "mishawaka",
  route: "/mishawaka",
  title: "Emergency Passport Mishawaka, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Mishawaka, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Mishawaka, South Bend, Granger, Osceola, and all St. Joseph County residents. A+ BBB rated courier service serving the Notre Dame area.",
  h1: "Emergency & Expedited Passport Services in Mishawaka, IN",
  heroSubtitle: "Mishawaka travelers — from St. Joseph County families and University Park Mall area professionals to Notre Dame-adjacent residents heading abroad — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, serving all of North Central Indiana.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Mishawaka%20Indiana%20cityscape%20along%20the%20St%20Joseph%20River%20featuring%20the%20historic%20riverwalk%20and%20modern%20downtown%20development%2C%20Princess%20City%20with%20tree%20lined%20streets%20and%20vibrant%20commercial%20district%2C%20Northern%20Indiana%20suburban%20charm%20with%20riverfront%20parks%20and%20green%20spaces%2C%20warm%20golden%20afternoon%20light%2C%20professional%20city%20photography%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=mishawaka-in-hero-001&orientation=landscape",
  heroImageAlt: "Mishawaka Indiana riverfront and downtown with St. Joseph River views",
  geoPosition: "41.6619;-86.1586",
  geoPlacename: "Mishawaka, Indiana",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 2 hours via I-80/I-90 — about 110 miles",
  },
  nearbyCitiesZips: [
    { name: "Mishawaka", zips: "46544, 46545, 46546" },
    { name: "South Bend", zips: "46601, 46613, 46614, 46615, 46616, 46617, 46619, 46628, 46635, 46637" },
    { name: "Granger", zips: "46530" },
    { name: "Osceola", zips: "46561" },
    { name: "Elkhart", zips: "46514, 46516, 46517" },
    { name: "Goshen", zips: "46526, 46528" },
    { name: "Niles", zips: "49120, 49121" },
    { name: "Bremen", zips: "46506" },
    { name: "Wakarusa", zips: "46573" },
    { name: "Edwardsburg area", zips: "49112" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — serving Mishawaka and all St. Joseph County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for the Notre Dame and Mishawaka area" },
    { icon: "ri-building-line", title: "Princess City Hub", desc: "Serving Mishawaka, South Bend, Granger, Osceola, and the Elkhart County border region" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in Mishawaka near Main Street or Grape Road" },
  ],
  internalLinks: [
    { name: "Expedited passport in South Bend, IN", route: "/south-bend" },
    { name: "Emergency passport help in Elkhart, IN", route: "/elkhart" },
    { name: "Urgent passport services in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Indiana passport services overview", route: "/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Mishawaka, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 110 miles — about 2 hours via I-80/I-90. We handle the drive so Mishawaka residents, St. Joseph County families, and Notre Dame-adjacent travelers never need to make the trip to Chicago themselves.",
  fpcOfficeDistance: "Serving Mishawaka, South Bend, Granger, Osceola, Niles MI, and all of St. Joseph County and the Michiana border region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Mishawaka and St. Joseph County. From the Grape Road commercial corridor and downtown riverfront to Granger, Osceola, and the Elkhart County border — we serve all of North Central Indiana's Michiana region.",
  nearbyCitiesIntro: "We serve Mishawaka and all nearby communities including South Bend, Granger, Osceola, Elkhart, Goshen, Niles (MI), Bremen, and Wakarusa. We also serve all of St. Joseph County and the greater Michiana region, including the Michigan border communities.",
  howItWorksIntro: "Most Mishawaka travelers — especially St. Joseph County families and University Park Mall area professionals — complete everything online and ship documents via overnight courier from any UPS or FedEx in the Mishawaka commercial district. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "Mishawaka sits at the heart of the Michiana region, adjacent to South Bend and the University of Notre Dame. Here are the most common passport mistakes we see from St. Joseph County travelers.",
  testimonialsIntro: "Mishawaka travelers — from St. Joseph County families to Grape Road area professionals to Granger and Osceola residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Mishawaka, IN? Here are the most common ones we hear from St. Joseph County and Michiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Chicago drive required — ship from Mishawaka", "Perfect for St. Joseph County families and Notre Dame-area travelers", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned family and business travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~2.5 hours each way)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Mishawaka travelers with immediate departure needs — as fast as 24 hours. Ideal for St. Joseph County families with sudden travel plans or unexpected passport issues before a trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 2.5-hour drive", "St. Joseph County family and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Mishawaka adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for Grape Road area professionals and St. Joseph County residents.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Mishawaka or St. Joseph County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Mishawaka residents, St. Joseph County families, and new citizens in the Michiana region.",
      bullets: ["Acceptance facility scheduling near Mishawaka", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Mishawaka residents — whether lost at home, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Mishawaka and St. Joseph County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Mishawaka and St. Joseph County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Mishawaka IN", description: "Urgent passport processing for Mishawaka Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Mishawaka IN", description: "Fast passport renewal for Mishawaka Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Mishawaka IN", description: "New passport application services for Mishawaka Indiana residents and St. Joseph County families." },
    { name: "Child Passport Mishawaka IN", description: "Minor passport services for Mishawaka Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Tom R.",
      location: "Mishawaka, IN — Near University Park Mall",
      rating: 5,
      text: "Family trip to Cancun in 7 days and discovered my daughter's passport was expired. The Mishawaka Post Office couldn't see us for 3 weeks. Fast Passport Center processed her renewal in 4 days. Absolute game-changer for St. Joseph County families.",
      service: "Child Passport Renewal",
    },
    {
      name: "Linda M.",
      location: "Mishawaka, IN — Riverfront District",
      rating: 5,
      text: "Business conference in Frankfurt with 10 days notice. Realized my passport had less than 2 months validity. Fast Passport Center got me a renewal in 3 days without me ever needing to drive to Chicago. Outstanding service.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Brian K.",
      location: "Granger, IN",
      rating: 5,
      text: "Mission trip to Guatemala and my first-time passport had an error on it. Fast Passport Center corrected everything and I had my corrected passport in 5 days. The courier service to Indianapolis saved me a drive to Chicago.",
      service: "Passport Correction",
    },
    {
      name: "Patricia W.",
      location: "Osceola, IN",
      rating: 5,
      text: "Lost my passport somewhere during a move from South Bend to Osceola. Had booked a European river cruise departing in 9 days. Fast Passport Center replaced it in 48 hours. Lifesavers — I never even had to leave St. Joseph County.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "mishawaka-in-1",
      name: "Mishawaka Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 E 3rd St",
      city: "Mishawaka",
      state: "IN",
      zip: "46544",
      phone: "(574) 255-5545",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Mishawaka, near the St. Joseph River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Mishawaka acceptance facility. Appointments recommended — call ahead. Located downtown near the riverfront and City Hall.",
      icon: "ri-mail-line",
    },
    {
      id: "mishawaka-in-2",
      name: "South Bend Post Office — Main",
      type: "USPS Passport Acceptance Facility",
      address: "424 S Michigan St",
      city: "South Bend",
      state: "IN",
      zip: "46601",
      phone: "(574) 282-8511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 5 miles west of Mishawaka, downtown South Bend",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest St. Joseph County acceptance facility in downtown South Bend. Good alternative when Mishawaka appointments are full. Near Notre Dame campus.",
      icon: "ri-mail-line",
    },
    {
      id: "mishawaka-in-3",
      name: "Granger Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12460 Adams Rd",
      city: "Granger",
      state: "IN",
      zip: "46530",
      phone: "(574) 271-0088",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 5 miles northeast of Mishawaka, in Granger",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northeast St. Joseph County facility serving Granger. Often has shorter wait times than Mishawaka or South Bend locations during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "mishawaka-in-4",
      name: "Elkhart Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "601 S Main St",
      city: "Elkhart",
      state: "IN",
      zip: "46516",
      phone: "(574) 293-0411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 12 miles east of Mishawaka, downtown Elkhart",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Elkhart County facility serving the eastern Michiana region. Good option for Mishawaka residents near the Elkhart County border.",
      icon: "ri-mail-line",
    },
    {
      id: "mishawaka-in-5",
      name: "St. Joseph County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "101 S Main St",
      city: "South Bend",
      state: "IN",
      zip: "46601",
      phone: "(574) 235-9635",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown South Bend, St. Joseph County Courthouse",
      website: "https://www.sjcindiana.com/",
      websiteLabel: "St. Joseph County",
      notes: "County clerk passport acceptance at the St. Joseph County Courthouse. Extended morning hours (opens at 8AM). Good alternative to post office facilities.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2-hour drive to Chicago via I-80/I-90", fpc: "No — ship from Mishawaka, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Notre Dame Area Travel", agency: "No special support for Michiana residents", fpc: "Experienced with St. Joseph County travelers" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Mishawaka residents driving 2.5 hours to the Chicago Passport Agency often assume they can walk in — they cannot. Appointments must be booked through NPIC and are extremely limited. Routine processing takes 8–11 weeks. Start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Chicago Drive",
      description: "A 2.5-hour drive down US-31 to the Chicago Passport Agency sounds manageable — until you factor in construction season (which in Indiana runs from March through November), weather delays, and the return trip. That is 5 hours of driving for a 15-minute appointment. Our courier service eliminates this entirely.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Retail photo services in Mishawaka — including those at University Park Mall — sometimes produce photos that fail Department of State standards. Photos must be exactly 2x2 inches on a white background with no filters, no smiling with teeth showing, and no glasses.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time passport applicants in St. Joseph County frequently miss signatures or submit the wrong form. DS-11 requires in-person execution at an acceptance facility. DS-82 (renewal) can be mailed for most adults holding a previously issued passport.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many European and Asian countries require at least 6 months of passport validity beyond your stay. St. Joseph County business travelers and Notre Dame-connected academics heading abroad frequently overlook this requirement until it is too late.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for Notre Dame Events",
      description: "Passport demand in the Mishawaka-South Bend area spikes around Notre Dame graduation (May), football season (September–November), and study abroad application deadlines (March and October). Acceptance facility appointments can fill 3–4 weeks in advance during these periods.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Mishawaka or St. Joseph County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in the Grape Road corridor." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for St. Joseph County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — no need to make the 2.5-hour drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Mishawaka address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Mishawaka, IN?", a: "Fast Passport Center offers emergency passport processing in Mishawaka, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) — no need to make the 2.5-hour drive yourself." },
    { q: "Does Mishawaka have its own passport agency?", a: "No — Mishawaka does not have a regional passport agency. The nearest is the Chicago Passport Agency, approximately 140 miles south (about 2.5 hours via US-31). Fast Passport Center's courier service handles the drive so Mishawaka and St. Joseph County residents never need to make the trip themselves." },
    { q: "Is Mishawaka part of the South Bend Metro area for passport services?", a: "Yes. Mishawaka and South Bend form the core of the Michiana metropolitan area. Fast Passport Center serves both cities and all surrounding communities in St. Joseph County with the same expedited courier service to the Chicago Passport Agency." },
    { q: "What airport do Mishawaka travelers use?", a: "South Bend International Airport (SBN) is the local airport, just 10 minutes from Mishawaka with connecting flights to major hubs. For direct international flights, Chicago O'Hare (ORD) is about 1.5 hours west via I-80/I-90, and Detroit Metro (DTW) is about 2.5 hours east via I-94." },
    { q: "How much does an expedited passport cost in Mishawaka?", a: "Government fees are fixed: $130 for a first-time adult passport or $130 + $60 expedite fee for a renewed adult passport book. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Mishawaka?", a: "Walgreens (multiple locations including 3601 Grape Rd and 1302 Lincolnway E), CVS (4000 Lincolnway E), and the UPS Store (6017 Grape Rd) all offer passport photos in Mishawaka. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Granger and Osceola residents?", a: "Yes. Fast Passport Center serves all of St. Joseph County including Mishawaka, Granger, Osceola, and the broader Michiana region. Our courier service works the same way for everyone — ship from your local UPS or FedEx, and we handle the Chicago delivery." },
    { q: "Can Notre Dame students and faculty get passport help in Mishawaka?", a: "Absolutely. While Notre Dame is in South Bend, our Mishawaka service covers the entire Notre Dame community. We understand the urgency of academic travel — conferences, research collaborations, and study abroad programs — and can coordinate expedited services to match academic deadlines." },
  ],
  photoLocations: [
    { name: "Walgreens — Mishawaka (Grape Rd)", address: "3601 Grape Rd, Mishawaka, IN 46545", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Mishawaka", address: "4000 Lincolnway E, Mishawaka, IN 46544", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Mishawaka (Grape Rd)", address: "6017 Grape Rd, Mishawaka, IN 46545", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Mishawaka (Lincolnway)", address: "1302 Lincolnway E, Mishawaka, IN 46544", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Mishawaka", address: "2424 Miracle Ln, Mishawaka, IN 46545", hours: "Mon–Fri: 8:30AM–6:00PM", note: "St. Joseph County BMV branch on Miracle Lane near Grape Road. Driver's licenses and REAL ID processing. Online reservations strongly recommended — this is the primary branch for Mishawaka and Granger residents.", featured: true },
    { name: "Indiana BMV — South Bend", address: "219 Lucas Dr, South Bend, IN 46601", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves South Bend and western St. Joseph County. Good alternative when Mishawaka branch is busy. REAL ID processing available near downtown.", featured: false },
  ],
  airports: [
    {
      code: "SBN",
      name: "South Bend International Airport",
      distance: "Approximately 10 minutes from Mishawaka — about 5 miles west",
      address: "4477 Progress Dr, South Bend, IN 46628",
      note: "Local airport for Mishawaka and St. Joseph County. Connecting flights to major hubs (Chicago, Detroit, Atlanta, Minneapolis). Convenient for domestic connections — international travelers typically connect through ORD or DTW.",
      flightUrl: "https://flysbn.com/",
      flightLabel: "SBN Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 1.5 hours west of Mishawaka via I-80/I-90 — about 100 miles",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Michiana travelers. One of the world's busiest airports with direct flights to destinations across six continents. Major hub for United and American Airlines.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "St. Joseph County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for St. Joseph County and all Indiana counties" },
    { label: "St. Joseph County Clerk: Marriage Licenses", url: "https://www.sjcindiana.com/", icon: "ri-heart-line", description: "St. Joseph County Clerk — marriage license records for Mishawaka and St. Joseph County" },
    { label: "St. Joseph County: Divorce Decrees", url: "https://www.sjcindiana.com/", icon: "ri-file-list-3-line", description: "St. Joseph County Clerk of Courts — divorce decree records for Mishawaka and St. Joseph County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Mishawaka address" },
  ],
};